/* The cart drawer's two small behaviours: copy the discount code, and keep the
   quantity stepper from deleting an item by surprise.

   Delegated from document, so it keeps working after the drawer re-renders:
   sections/minicart-form.liquid replaces the footer on every quantity change,
   and a listener bound to the button itself would die with it.

   The trigger must be type="button". In some drawer states the coupon block
   sits inside the minicart form, and a default-type button there submits the
   form — which is checkout. */
(function () {
  'use strict';

  function flash(el) {
    el.setAttribute('data-copied', 'true');
    window.clearTimeout(el._gsTimer);
    el._gsTimer = window.setTimeout(function () {
      el.removeAttribute('data-copied');
    }, 1800);
  }

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:-1000px;left:-1000px;opacity:0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('[data-gs-copy]');
    if (!el) return;
    e.preventDefault();

    var code = el.getAttribute('data-gs-copy');
    if (!code) return;

    /* navigator.clipboard is undefined on insecure origins and can still
       reject when the document is not focused, so the textarea path is a
       real fallback rather than a formality. */
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(
        function () { flash(el); },
        function () { if (legacyCopy(code)) flash(el); }
      );
    } else if (legacyCopy(code)) {
      flash(el);
    }
  });
})();

/* ---------------------------------------------------------------------------
   Quantity stepper.

   The input carries min="0", so pressing minus at quantity 1 takes the line to
   zero and the item disappears with no warning and no undo. The card already
   has an explicit remove control in its top-right corner, so the destructive
   path stays available — it just stops being something you can trigger while
   trying to buy one fewer.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var STEPPER = '.minicart__wrapper quantity-input';

  function qtyOf(stepper) {
    var input = stepper.querySelector('input');
    return input ? parseInt(input.value, 10) || 0 : 0;
  }

  function sync() {
    var steppers = document.querySelectorAll(STEPPER);
    for (var i = 0; i < steppers.length; i++) {
      var minus = steppers[i].querySelector('[name="minus"]');
      if (!minus) continue;
      var atMin = qtyOf(steppers[i]) <= 1;
      minus.classList.toggle('is-min', atMin);
      minus.setAttribute('aria-disabled', atMin ? 'true' : 'false');
      if (atMin) {
        minus.setAttribute('title', 'Use the bin to remove this item');
      } else {
        minus.removeAttribute('title');
      }
    }
  }

  /* Capture phase, so this runs before the theme's own handler on the button. */
  document.addEventListener('click', function (e) {
    var minus = e.target && e.target.closest && e.target.closest(STEPPER + ' [name="minus"]');
    if (!minus) return;
    var stepper = minus.closest('quantity-input');
    if (stepper && qtyOf(stepper) <= 1) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('change', sync);
  document.addEventListener('input', sync);

  /* A poll, deliberately, rather than more listeners.

     Updating a quantity re-renders the drawer more than once, and the theme
     assigns input.value as a property — which mutates nothing and fires no
     event. Every attempt to time a pass against that sequence lost the race and
     left the button showing the previous quantity's state. Two selector calls
     on a handful of nodes is not worth being clever about.

     This is presentation only. The guard that actually stops the deletion reads
     the live value at click time and does not depend on it. */
  window.setInterval(sync, 700);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
